module.exports = __webpack_public_path__ + "static/cliente_4-06beb0ffd8ff0fd1561dc6507072c954.png";